import React, { useEffect, useRef, useState } from "react";
import { Row, Form, Col, Button, Container } from "react-bootstrap";
import pdfIcon from "../../../Assets/Images/CRM/pdf.svg";
import { commonService } from "../../../utils/commonService";
import DatePicker from "react-datepicker";
import { API_URL } from "../../../utils/apiRoutes";
import { validationRule } from "../../../utils/constant";
import { hotelListCommon } from "../Hotels/HotelListCommon";
import { AccountListCommon } from "../Contacts/AccountListCommon";
import { checkValidation } from "../../../utils/helper";
import { apiCall } from "../../../utils/axiosService";
import { apiResponse } from "../../../utils/apiResponse";
import { successToastMessage } from "../../../utils/toastMessage";
import Select from "react-select";
import filterIcon from "../../../Assets/Images/CRM/filter.png";
import { useSelector } from "react-redux";
import Loader from "../../Loader/Loader";
import { Link } from "react-router-dom";

const LeadReport = ({ title }) => {
    const [selectStatusTerm, setStatusTerm] = useState([]);
    const [termList, setTermList] = useState([]);
    const [selectProperty, setSelectProperty] = useState([]);
    const [propertyValue, setPropertyValue] = useState([]);
    const [selectAccount, setSelectAccount] = useState([]);
    const [accountValue, setAccountValue] = useState([]);
    const [selectSource, setSelectSource] = useState([]);
    const [sourceValue, setSourceValue] = useState([]);
    const userIDList = useRef("");
    const statusList = useRef("");
    const propertyIdList = useRef("");
    const SourceList = useRef("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const setPdfRef = useRef("");
    const [showPdf, setShowPdf] = useState(false);
    const [showAllReport, setshowAllReport] = useState(false);
    const isDefaultApiCalledRef = useRef(false);
    const userDetails = commonService.getLoginUserData();

    const handleshowAllReport = () => {
        setshowAllReport(!showAllReport);
    };

    const crmPropertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.crmPropertyDetail
    );

    let propertyIdPayload = "";
    if (crmPropertyDetailFromRTK) {
        if (crmPropertyDetailFromRTK?.propertyid === "") {
            let propertyPayload = crmPropertyDetailFromRTK?.allPropertyId;
            propertyIdPayload = propertyPayload.slice(0, -1);
        } else {
            propertyIdPayload = crmPropertyDetailFromRTK?.propertyid?.toString();
        }
    }

    let startDate = new Date();
    let endDate = new Date(startDate.getTime() - 7 * 24 * 60 * 60 * 1000);

    let validationObj = {
        propertyID: "",
        userID: "",
        status: "",
        source: "",
        startDate: endDate,
        endDate: startDate,

        validationRule: [
            {
                fieldName: "propertyID",
                rule: validationRule.required,
                message: "Property required",
            },
            {
                fieldName: "userID",
                rule: validationRule.required,
                message: "User is required",
            },
            {
                fieldName: "startDate",
                rule: validationRule.required,
                message: "Start Date is required",
            },
            {
                fieldName: "endDate",
                rule: validationRule.required,
                message: "End Date is required",
            },
            {
                fieldName: "status",
                rule: validationRule.required,
                message: "Status is required",
            },
            {
                fieldName: "source",
                rule: validationRule.required,
                message: "Source is required",
            },
        ],
        errorObj: {},
        isValidate: true,
    };
    const [leadReportData, setLeadReportData] = useState(validationObj);
    const leadReportDataRef = useRef(leadReportData);

    const handleDateChange = (dates) => {
        const [start, end] = dates;
        leadReportDataRef.current.startDate = start;
        leadReportDataRef.current.endDate = end;
        setLeadReportData({
            ...leadReportData,
            startDate: start,
            endDate: end,
        });
    };

    //get Property List
    const getHotelList = async () => {
        let response = await hotelListCommon(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.CRM +
                    API_URL.PROPERTY_TERM.GET_PROPERTY_LIST_BY_USER_ID,
                body: {
                    id: userDetails?.userid,
                },
            },
            false
        );

        if (response?.isValidate) {
            let propertyListarry = [];
            response?.data?.map((item) => {
                propertyListarry = [
                    ...propertyListarry,
                    {
                        label: item?.propertyname,
                        value: item?.propertyid,
                    },
                ];
            });
            setSelectProperty(propertyListarry);

            if (crmPropertyDetailFromRTK?.propertyid !== "") {
                setPropertyValue([
                    {
                        label: crmPropertyDetailFromRTK?.propertyname,
                        value: crmPropertyDetailFromRTK?.propertyid,
                    },
                ]);
                propertyIdList.current = `${crmPropertyDetailFromRTK?.propertyid}`;
                leadReportDataRef.current.propertyID = propertyIdList.current;
                setLeadReportData(leadReportDataRef.current);
            }
        }
    };
    const iframeloader = () => {
        setLoading(false)
    };

    //get Account/User List
    const getUserList = async (propertyId) => {
        let userResponse = await AccountListCommon(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.UserManagement +
                    API_URL.USER_ROLE_PROPERTY.GET_USER_LIST_BY_MODULE_MULTI_PROPERTY,
                body: {
                    propertyid: leadReportData.propertyID,
                    modulename: "crm",
                },
            },
            false
        );

        if (userResponse?.isValidate) {
            let userDropList = [],
                userIds = [];
            userResponse?.data?.map((item) => {
                userDropList = [
                    ...userDropList,
                    {
                        label: item?.displayname,
                        value: item?.userid,
                    },
                ];
                userIds = [...userIds, item?.userid];
            });
            setSelectAccount(userDropList);
            setAccountValue(userDropList);
            userIDList.current = userIds?.join(",");
            leadReportDataRef.current.userID = userIDList.current;
            setLeadReportData(leadReportDataRef.current);
        }
    };

    //Opportunity Status
    const getTermListByMulCategory = async () => {
        let termListByMulCategoryResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY,
                body: {
                    categorynamebycomma: "Source,Lead Status",
                },
            },
            false
        );

        let response = apiResponse(false, termListByMulCategoryResponse);

        if (response?.isValidate) {
            // setTermList(response?.data?.data);
            let userDropList = [];
            let sourceList = [],
                statusData = [],
                sourceData = [];
            if (response?.data?.data)
                response?.data?.data?.map((item) => {
                    if (item?.termcategoryname === "Lead Status") {
                        userDropList = [
                            ...userDropList,
                            {
                                label: item?.term,
                                value: item?.term,
                            },
                        ];
                        statusData = [...statusData, item?.term];
                        // setTermList(userDropList);
                    } else {
                        sourceList = [
                            ...sourceList,
                            {
                                label: item?.term,
                                value: item?.term,
                            },
                        ];
                        sourceData = [...sourceData, item?.term];
                        // setSelectSource(sourceList);
                    }
                });
            setTermList(userDropList);
            setStatusTerm(userDropList);
            setSelectSource(sourceList);
            setSourceValue(sourceList);
            statusList.current = statusData?.join(",");
            SourceList.current = sourceData?.join(",");
            leadReportDataRef.current.status = statusList.current;
            leadReportDataRef.current.source = SourceList.current;
            setLeadReportData(leadReportDataRef.current);
        }
    };

    //on account/user dropdown
    const handleAccountSelection = (e) => {
        if (e?.length <= 0) {
            setAccountValue([]);
            leadReportDataRef.current.userID = "";
            setLeadReportData(leadReportDataRef.current);
            return;
        }
        setAccountValue(e);
        let propertyList = [];
        e?.map((item) => {
            propertyList = [...propertyList, item?.value?.toString()];
        });
        userIDList.current = propertyList?.join(",");
        leadReportDataRef.current.userID = userIDList.current;
        setLeadReportData(leadReportDataRef.current);
    };

    //select status drop
    const handleStatusSelection = (e) => {
        if (e?.length <= 0) {
            setStatusTerm([]);
        }
        setStatusTerm(e);
        let propertyList = [];
        e?.map((item) => {
            propertyList = [...propertyList, item?.value?.toString()];
        });
        statusList.current = propertyList?.join(",");
        leadReportDataRef.current.status = statusList.current;
        setLeadReportData(leadReportDataRef.current);
    };

    // select Source term
    const handleSourceSelection = (e) => {
        if (e?.length <= 0) {
            setSourceValue([]);
        }
        setSourceValue(e);
        let sourceListArry = [];
        e?.map((item) => {
            sourceListArry = [...sourceListArry, item?.value?.toString()];
        });
        SourceList.current = sourceListArry?.join(",");
        leadReportDataRef.current.source = SourceList.current;
        setLeadReportData(leadReportDataRef.current);
    };

    //select multi property
    const handlePropertySelectionFc = (e) => {
        if (e?.length <= 0) {
            setPropertyValue([]);
            setAccountValue([]);
            leadReportDataRef.current.userID = "";
            leadReportDataRef.current.propertyID = "";
            setLeadReportData(leadReportDataRef.current);
            return;
        }
        setPropertyValue(e);
        let propertyList = [];
        e?.map((item) => {
            propertyList = [...propertyList, item?.value?.toString()];
        });
        propertyIdList.current = propertyList?.join(",");
        leadReportDataRef.current.propertyID = propertyIdList.current;
        setLeadReportData(leadReportDataRef.current);
    };

    const GenerateReportbtn = async () => {
        setShowPdf(false);
        setLoading(true);
        let validation = checkValidation(leadReportData);

        if (!validation.isValidate) {
            leadReportDataRef.current = validation;
            setLeadReportData(validation);
            setLoading(false);
            return;
        }

        let ActivitiesReport = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.CRM + API_URL.CRM_REPORT.LEAD_REPORT,
                body: {
                    propertyID: leadReportData.propertyID,
                    userID: leadReportData.userID.toString(),
                    status: leadReportData.status,
                    source: leadReportData.source,
                    startDate: commonService.getDateInDBFormat(
                        new Date(leadReportData.startDate)
                    ),
                    endDate: commonService.getDateInDBFormat(
                        new Date(leadReportData.endDate)
                    ),
                },
            },
            false
        );
        let response = apiResponse(false, ActivitiesReport);

        if (response?.isValidate) {
            isDefaultApiCalledRef.current = true;
            // setLoading(false);
            setshowAllReport(false);
            setErrorMessage(false);
            // successToastMessage(response?.message);
            setPdfRef.current =
                process.env.REACT_APP_APIBASEPATH_CRM_REPORT_PDF + response.data.data;
            setShowPdf(true);
        }

        if (!response?.isValidate) {
            isDefaultApiCalledRef.current = true;
            setshowAllReport(true);
            setLoading(false);
            setErrorMessage(true);
        }
    };

    useEffect(() => {
        if (leadReportData.propertyID !== "") {
            if (
                !isDefaultApiCalledRef.current &&
                leadReportData.userID !== "" &&
                leadReportData.status !== "" &&
                leadReportData.source !== ""
            ) {
                GenerateReportbtn();
            }
        }
    }, [
        leadReportData.propertyID,
        leadReportData.userID,
        leadReportData.status,
        leadReportData.source,
    ]);

    useEffect(() => {
        if (crmPropertyDetailFromRTK?.propertyid === "") {
            isDefaultApiCalledRef.current = true;
            setshowAllReport(true);
        }
        getTermListByMulCategory();
        getHotelList();
    }, []);

    useEffect(() => {
        if (leadReportData.propertyID !== "") {
            getUserList();
        }
    }, [leadReportData.propertyID]);

    return (
        <div className="all-reports-main ToolsDisplacementCalcMain">
            <Container fluid>
                <Row>
                    <Col xl={12}>
                        <div className="ProspectDashboardTitleWraper  d-flex justify-content-between align-items-center marginBottom20">
                            <h2 className="d-flex align-items-center gap-1">
                                <Link id={commonService.generateGlobalClickTrackerID("LeadReport", "dashboard", "")} to="/crm/dashboard">Dashboard - </Link>{" "}
                                <span className="tab-title-main">{title}</span>
                            </h2>
                            <div className="heading-menu-btns">
                                <img id={commonService.generateGlobalClickTrackerID("LeadReport", "filter-report", "")}
                                    src={filterIcon}
                                    alt="filterIcon"
                                    title="Filter Report"
                                    className="cursorPointer report-filter"
                                    onClick={handleshowAllReport}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>

                {showAllReport && (
                    <div className="displacementCalcWrapper width400">
                        <div className="from-groups no-border-break mb-2 small-height-select">
                            <Form.Label>Select Property</Form.Label>
                            <Select id={commonService.generateGlobalClickTrackerID("LeadReport", "select-property", "")}
                                isMulti
                                value={propertyValue}
                                options={selectProperty}
                                onChange={(e) => {
                                    handlePropertySelectionFc(e);
                                }}
                            />
                            {leadReportData?.errorObj?.propertyID &&
                                leadReportData?.propertyID === "" && (
                                    <small className="text-danger">
                                        {leadReportData?.errorObj?.propertyID}
                                    </small>
                                )}
                        </div>

                        <div className="from-groups no-border-break mb-2 small-height-select">
                            <Form.Label>Select User</Form.Label>
                            <Select id={commonService.generateGlobalClickTrackerID("LeadReport", "select-user", "")}
                                isMulti
                                value={accountValue}
                                options={selectAccount}
                                onChange={(e) => {
                                    handleAccountSelection(e);
                                }}
                            />
                            {leadReportData?.errorObj?.userID &&
                                leadReportData?.userID === "" && (
                                    <small className="text-danger">
                                        {leadReportData?.errorObj?.userID}
                                    </small>
                                )}
                        </div>

                        <div className="from-groups no-border-break mb-2 small-height-select">
                            <Form.Label>Select Opportunity Status</Form.Label>
                            <Select id={commonService.generateGlobalClickTrackerID("LeadReport", "select-opportunity-status", "")}
                                isMulti
                                value={selectStatusTerm}
                                options={termList}
                                onChange={(e) => {
                                    handleStatusSelection(e);
                                }}
                            />
                            {leadReportData?.errorObj?.status &&
                                leadReportData?.status === "" && (
                                    <small className="text-danger">
                                        {leadReportData?.errorObj?.status}
                                    </small>
                                )}
                        </div>

                        <div className="from-groups no-border-break mb-2 small-height-select">
                            <Form.Label>Select Source</Form.Label>
                            <Select id={commonService.generateGlobalClickTrackerID("LeadReport", "select-source", "")}
                                isMulti
                                value={sourceValue}
                                options={selectSource}
                                onChange={(e) => {
                                    handleSourceSelection(e);
                                }}
                            />
                            {leadReportData?.errorObj?.source &&
                                leadReportData?.source === "" && (
                                    <small className="text-danger">
                                        {leadReportData?.errorObj?.source}
                                    </small>
                                )}
                        </div>
                        <div className="startFrom from-groups no-border-break mb-4 meghaDatePicker">
                            <Form.Label htmlFor="startDate">Date Range</Form.Label>
                            <DatePicker id={commonService.generateGlobalClickTrackerID("LeadReport", "date-range", "")}
                                portalId="datepicker-root"
                                onChange={handleDateChange}
                                startDate={leadReportData.startDate}
                                endDate={leadReportData.endDate}
                                selectsRange
                                monthsShown={2}
                            />
                        </div>
                        <div className="d-flex gap-3 align-items-center justify-content-end">
                            {loading ? (
                                <button
                                    className="default-btn primary-btn d-flex gap-1 align-items-center"
                                    type="button"
                                    disabled
                                >
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Loading...
                                </button>
                            ) : (
                                <button id={commonService.generateGlobalClickTrackerID("LeadReport", "generate-report", "")}
                                    className="default-btn primary-btn d-flex gap-1 align-items-center"
                                    onClick={() => {
                                        GenerateReportbtn();
                                    }}
                                >
                                    <span className="revpak-icon">
                                        <img src={pdfIcon} alt="" />
                                    </span>
                                    <span>Generate Report</span>
                                </button>
                            )}
                        </div>
                    </div>
                )}
                <p className="text-center">{errorMessage && " No Record Found"}</p>
                {loading && <Loader />}
                <div className="pdf-is-showing-here mt-3">
                    {showPdf && setPdfRef.current && (
                        <iframe
                            onLoad={iframeloader}
                            title="Report Doc"
                            src={setPdfRef.current}
                            width="100%"
                            height="800px"
                        />
                    )}
                </div>
                {/* {loading ? (
          <Loader />
        ) : (
        
          <div className="pdf-is-showing-here mt-3">
            {showPdf && setPdfRef.current && (
              <iframe
              onLoad={checkLoad}
                title="Report Doc"
                src={setPdfRef.current}
                width="100%"
                height="800px"
              />
            )}
          </div>
        )} */}
            </Container>
        </div>
    );
};

export default LeadReport;
